import {
  FormControl,
  FormControlLabel,
  FormGroup,
  Switch as MaterialSwitch,
} from "@mui/material";
import { SwitchProps } from ".";
import { SPACING_SM } from "@shape-ds/tokens";

const Switch = ({
  label,
  checked,
  disabled,
  name,
  required,
  labelPosition,
  onChange,
  color,
  sx,
}: SwitchProps) => {
  const alignTo = labelPosition ?? "end";
  const sxOverride = {
    ...sx,
    ...(alignTo !== "end" && { marginLeft: SPACING_SM }),
  };

  return (
    <FormControl>
      <FormGroup>
        <FormControlLabel
          label={label}
          labelPlacement={alignTo}
          required={required}
          control={
            <MaterialSwitch
              name={name}
              checked={checked}
              disabled={disabled}
              onChange={onChange}
              sx={sxOverride}
              {...(color && { color })}
            />
          }
        />
      </FormGroup>
    </FormControl>
  );
};

export default Switch;
